import $http from '../utils/http';

export const getAppData = (encodedUserID, iosIAS, iosAPN, androidAPN, deeplink) => {
  return $http(`/app-link-data?uid=${encodedUserID}&iosias=${iosIAS}&iosapn=${iosAPN}&androidapn=${androidAPN}&deeplink=${deeplink}`, null, 'GET', null);
};
